import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['vatRate', 'totalHt', 'totalVat', 'totalTtc', 'linesWrapper'];

    connect() {
        // On n'observe QUE la zone des lignes, jamais this.element : _update() écrit le
        // textContent des totaux, qui vivent dans le même élément si on observe trop large,
        // ce qui redéclenche l'observer à l'infini et fige la page (boucle MutationObserver).
        const observedRoot = this.hasLinesWrapperTarget ? this.linesWrapperTarget : this.element;
        this._observer = new MutationObserver(() => this._update());
        this._observer.observe(observedRoot, { childList: true, subtree: true });
        this.element.addEventListener('input', () => this._update());
        this._update();
    }

    disconnect() {
        this._observer?.disconnect();
    }

    _update() {
        let totalHtCents = 0;

        this.element.querySelectorAll('[data-collection-entry="true"]:not([hidden])').forEach((entry) => {
            const qtyInput = entry.querySelector('[data-line-qty]');
            const priceInput = entry.querySelector('[data-line-price]');
            const discountInput = entry.querySelector('[data-line-discount]');

            const qty = parseInt(qtyInput?.value ?? '1', 10) || 1;
            const price = this._parseCents(priceInput?.value ?? '0');
            const discount = this._parseCents(discountInput?.value ?? '0');

            totalHtCents += Math.max(0, qty * price - discount);
        });

        const vatRate = parseInt(this.hasVatRateTarget ? this.vatRateTarget.value : '20', 10) || 0;
        const vatCents = Math.round(totalHtCents * vatRate / 100);
        const ttcCents = totalHtCents + vatCents;

        if (this.hasTotalHtTarget) this.totalHtTarget.textContent = this._formatEuros(totalHtCents);
        if (this.hasTotalVatTarget) this.totalVatTarget.textContent = this._formatEuros(vatCents);
        if (this.hasTotalTtcTarget) this.totalTtcTarget.textContent = this._formatEuros(ttcCents);
    }

    _parseCents(value) {
        const normalized = String(value).replace(',', '.').replace(/[^0-9.]/g, '');
        return Math.round(parseFloat(normalized || '0') * 100);
    }

    _formatEuros(cents) {
        return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
}
